export default "__VITE_ASSET__BRzemCRw__"